export const mapDataForClient = (item) => {
  const fullDate = new Date(item?.date);
  let startHours = '';
  let minutes = '';
  let endHours = '';
  let endDate = '';

  if (!Number.isNaN(fullDate)) {
    startHours = fullDate.getHours().toString().padStart(2, '0');
    minutes = fullDate.getMinutes().toString().padStart(2, '0'); 
    endHours = Number(startHours) + Number(item?.duration?.hours);
  }

  if (item?.duration?.days) {
    endDate = new Date(fullDate);
    endDate.setDate(endDate.getDate() + item?.duration?.days);
  }

  return {
    id: item?.id,
    duration: item?.duration,
    resourceId: item?.resourceId,
    confirmed: item?.confirmed,
    from: `${startHours}.${minutes}`,
    to: `${endHours}.${minutes}`,
    fullDate,
    date: new Date(item?.date).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
    }),
    endDate:
      endDate 
      && new Date(endDate).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
      }),
  };
};
